import React from 'react';

import { useMantineTheme } from '@mantine/core';

interface Props {
    size?: number;
    dimmed?: boolean;
}

export const UL = ({ size = 32, dimmed = false }: Props) => {
    const theme = useMantineTheme();

    const color = 'currentColor';

    return (
        <svg
            width={size}
            height={size}
            viewBox="-4.5140625 -4.5140625 159.496875 159.496875"
            fill={dimmed ? theme.colors.gray[5] : color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M 75.25,0 C 33.70215,0 0,33.66602 0,75.21875 C 0,116.7666 33.70215,150.46875 75.25,150.46875 C 116.79785,150.46875 150.46875,116.7666 150.46875,75.21875 C 150.46875,33.66602 116.79785,0 75.25,0 z M 75.25,13.96875 C 109.08301,13.96875 136.5,41.38574 136.5,75.21875 C 136.5,109.05664 109.08301,136.46875 75.25,136.46875 C 41.41211,136.46875 13.96875,109.05664 13.96875,75.21875 C 13.96875,41.38574 41.41211,13.96875 75.25,13.96875 z"
                id="path4216"
            />
            <path
                d="M 38.53125,34.87402 L 52.40821,34.87402 L 52.40821,79.57617 C 52.40821,82.41797 53.27735,84.86426 57.22754,84.86426 C 60.86524,84.86426 61.97364,81.70508 61.97364,79.18066 L 61.97364,34.87402 L 75.84571,34.87402 L 75.84571,77.75977 C 75.84571,87.78906 71.35352,95.5332 57.14942,95.5332 C 45.3916,95.5332 38.53125,89.92285 38.53125,77.75977 L 38.53125,34.87402"
                id="path4220"
            />
            <path
                d="M 81.30957,115.58203 L 81.30957,56.29981 L 95.18164,56.29981 L 95.18164,103.70215 L 112.16895,103.70215 L 112.16895,115.58203 L 81.30957,115.58203"
                id="path4222"
            />
            <path
                d="M 55.4502,103.61426 L 56.89063,103.61426 C 57.5791,103.61426 58.81934,103.65332 58.84864,105.23535 C 58.87305,106.84668 57.54004,106.91992 57.06153,106.93457 L 55.4502,106.93457 L 55.4502,103.61426 M 55.4502,107.85742 L 57.23243,107.85742 C 58.43848,107.85742 58.80957,108.64356 58.80957,109.56641 C 58.80957,110.18164 58.90723,111.31934 59.12696,111.91016 L 60.32325,111.91016 L 60.32325,111.7002 C 60.07422,111.7002 60.00098,111.29492 59.96192,111.12402 C 59.86426,110.43555 59.80567,109.76172 59.7666,109.07324 C 59.62012,107.84766 59.32715,107.46191 58.13086,107.35449 L 58.13086,107.33008 C 59.2002,107.17871 59.86426,106.40234 59.90332,105.32324 C 59.96192,103.19434 58.73633,102.69141 56.80274,102.69141 L 54.42969,102.69141 L 54.42969,111.91016 L 55.4502,111.91016 L 55.4502,107.85742"
                id="path4224"
            />
            <path
                d="M 57.21289,115.2793 C 61.61719,115.2793 65.19141,111.70508 65.19141,107.30078 C 65.19141,102.8916 61.61719,99.32227 57.21289,99.32227 C 52.80371,99.32227 49.2295,102.8916 49.2295,107.30078 C 49.2295,111.70508 52.80371,115.2793 57.21289,115.2793 z"
                id="path4226"
            />
        </svg>
    );
};
